import { formatPrice, getCurrencySymbol } from '@lib/utils/formatPrice'

interface PriceDisplayProps {
	price: {
		amount: string
		currencyCode: string
	}
	className?: string
}

export default function PriceDisplay({ price, className = '' }: PriceDisplayProps) {
	return (
		<span className={`bg-bbx-style text-white text-xs font-bold px-2 py-0.5 mb-1 ${className}`}>
			{getCurrencySymbol()}
			{formatPrice(price.amount)} VALUE
		</span>
	)
}
